export default {}

export const SortUtils = {
    sort(arrayToSort, { prop, order }) {
        if (prop) {
            return arrayToSort.sort((a, b) => {
            let aVal = a[prop]
            let bVal = b[prop]
            if (order === 'ascending') {
                return aVal > bVal ? 1 : -1
            }
            return bVal - aVal ? 1 : -1
            })
        } else {
            return arrayToSort.sort((a, b) => {
            return a.id - b.id
            })
        }
    },
    sortAsc(arrayToSort, { prop }) {
        return this.sort(arrayToSort, {prop, order: 'ascending' });
    },
    sortDesc(arrayToSort, { prop }){
        return this.sort(arrayToSort, {prop});
    },
    sortAscWithOrder(arrayToSort, { prop }) {
        var withOrder = arrayToSort.filter(v => v.order);
        var withoutOrder = arrayToSort.filter(v => !v.order);
        var withOrderSorted = this.sortAsc(withOrder, { prop: 'order' });
        var withoutOrderSorted = this.sortAsc(withoutOrder, { prop: 'text' });
        var sorted = withOrderSorted.concat(withoutOrderSorted);
        return sorted;
    }
}

export const isNullOrEmpty = function(value) {
    return value == '' || value == null || value == undefined;
}

export  const getReturnUrlParam = function() {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get('returnUrl');
}